import { define, html } from "hybrids";
import { VUiButton } from "~/modules/ui/elements/Button";

export interface VBroadcastClapBubbles {
  likes: number;
  render: () => HTMLElement;
}

export default define<VBroadcastClapBubbles>({
  tag: "v-broadcast-clap-bubbles",
  likes: {
    value: 0,
    observe({ render }, value, lastValue) {
      if (lastValue === undefined) return;

      const diff = value - lastValue;

      for (let i = 0; i < diff; i += 1) {
        const el = document.createElement("v-ui-button") as VUiButton;
        el.icon = "applause";
        el.type = "round";
        el.color = Math.random() > 0.5 ? "primary" : "secondary";
        el.style.animationName = `clap-${Math.round(Math.random() * 3) + 1}`;
        el.tabIndex = -1;

        el.onanimationend = () => el.parentNode?.removeChild(el);
        const target = render();
        target.insertBefore(el, target.lastChild);
      }
    },
  },
  render: () => html`<slot></slot>`.css`
    :host {
      display: block;
      position: relative;
    }

    ::slotted(*) {
      position: relative;
      z-index: 2;
    }

    v-ui-button {
      position: absolute;
      z-index: 1;
      pointer-events: none;
      width: 24px;
      height: 24px;
      left: calc(50% - 10px);
      top: 0;
      animation-duration: 2.5s;
      animation-fill-mode: forwards;
    }

    @keyframes clap-1 {
      100% {
        transform: translateX(50%) translateY(-500%) scale(1.5);
        opacity: 0;
      }
    }

    @keyframes clap-2 {
      100% {
        transform: translateX(100%) translateY(-500%) scale(1.3);
        opacity: 0;
      }
    }

    @keyframes clap-3 {
      100% {
        transform: translateX(-80%) translateY(-500%) scale(1.7);
        opacity: 0;
      }
    }

    @keyframes clap-4 {
      100% {
        transform: translateX(0%) translateY(-500%) scale(1.9);
        opacity: 0;
      }
    }
  `,
});
